<template>
<div>
  <van-nav-bar @click-left="onClickLeft" :border="false">
    <span slot="left" style="font-size: 17px">
       <van-icon color="black" name="arrow-left"></van-icon>
    </span>
    <span slot="title" style="font-size: 17px;color: #505050">订单记录</span>
  </van-nav-bar>
<!--  <van-search v-model="telAndName" placeholder="请输入姓名/电话" shape="round"></van-search>-->
  <van-tabs class="orderTab" :border="false" v-model="active" @click="onClick" :ellipsis="false" line-width="2.93vw" line-height=".8vw">
    <van-tab :replace="true"  name="0">
      <div slot="title" style="position: relative">
        {{'全部'}}
      </div>
      <div style="overflow-y: auto; background-color: #f6f7f8;height: calc(100vh - 98px)" class="search">
          <van-search
            v-model="form.orderNo"
            show-action
            shape="round"
            ref="searchInput"
            background="white"
            style="position: relative; z-index: 10"
            placeholder="请输入想搜索的订单"
          >
            <div slot="left-icon">
              <img src="../../assets/img/icon/searchGray.png" style="width: 13px;margin-left: 13px;transform: translateY(1px)">
            </div>
            <div style="line-height: 20px;color: #2B2D2F; width: 30px;transform: translateX(5px)" class="centerBox"  slot="action">
              <div style="font-size: 14px;" @click="orderPage">搜索</div>
            </div>
          </van-search>
          <div style="width: 92%;margin: 2.67vw auto;border-radius: 2.67vw; overflow: hidden;background-color: white;position: relative" @click="toDetail(item)" v-for="(item, index) in list" :key="index">
          <div style="position: relative;height: 9.07vw;justify-content: left;border-bottom: .13vw solid rgba(151, 151, 151, 0.21);padding: 0 2.93vw;width: calc(100% - 2.93vw)" class="centerBox">
            <div style="color: #333333; font-size: 3.47vw;font-weight: bold">订单号: {{item.orderNo}}</div>
            <div style="margin-left: 3.47vw;color: #353535;font-size: 3.2vw;transform: translateY(.3vw)">{{$utils.ymdDate(item.orderTime, '-')}}</div>
            <img src="../../assets/img/order/shzTitle.png" v-if="item.orderStatus === 1" style="width: 13.33vw;position: absolute;right: 5.43vw;top: 2.13vw">
            <img src="../../assets/img/order/yshTitle.png" v-if="item.orderStatus === 2" style="width: 13.33vw;position: absolute;right: 5.43vw;top: 2.13vw">
            <img src="../../assets/img/order/yfkTitle.png" v-if="item.orderStatus === 3" style="width: 13.33vw;position: absolute;right: 5.43vw;top: 2.13vw">
            <img src="../../assets/img/order/yjsTitle.png" v-if="item.orderStatus === 4" style="width: 13.33vw;position: absolute;right: 5.43vw;top: 2.13vw">
          </div>
          <div style="height: calc(25.6vw - 5.07 * 2vw);padding: 5.07vw 2.93vw">
            <div style="justify-content: space-between" class="centerBox">
              <div style="display: flex;align-items: center;width: 67vw;overflow-x: hidden">
                <div  v-for="(children, index) in item.orderItemLists" :key="children.id">
                  <div style="margin-right: 3.73vw" v-if="index < 6">
                    <img :src="children.img" style="width: 10.13vw;height: 10.13vw">
                    <div style="width: 10.13vw;margin-top: 1.33vw;font-size: 2.67vw;color: #535353" class="primaryText">
                      {{children.goodsName}}
                    </div>
                  </div>
                </div>
              </div>
              <div style="font-size: 3.47vw;color: #535353">
                <van-icon v-if="item.orderItemLists > 5" name="ellipsis" style="margin-right: 1.33vw" />
                共{{item.orderItemLists.length}}件
              </div>
            </div>
          </div>
        </div>
        </div>
<!--      <allOrders></allOrders>-->
    </van-tab>
    <van-tab name="5">
      <div slot="title" style="position: relative">
        {{'审核中'}}
      </div>
      <div style="overflow-y: auto; background-color: #f6f7f8;height: calc(100vh - 98px)" class="search">
          <van-search
            v-model="form.orderNo"
            show-action
            shape="round"
            ref="searchInput"
            background="white"
            style="position: relative; z-index: 10"
            placeholder="请输入想搜索的订单"
          >
            <div slot="left-icon">
              <img src="../../assets/img/icon/searchGray.png" style="width: 13px;margin-left: 13px;transform: translateY(1px)">
            </div>
            <div style="line-height: 20px;color: #2B2D2F; width: 30px;transform: translateX(5px)" class="centerBox"  slot="action">
              <div style="font-size: 14px;" @click="orderPage">搜索</div>
            </div>
          </van-search>
          <div style="width: 92%;margin: 2.67vw auto;border-radius: 2.67vw; overflow: hidden;background-color: white;position: relative" @click="toDetail(item)" v-for="(item, index) in list" :key="index">
          <div style="position: relative;height: 9.07vw;justify-content: left;border-bottom: .13vw solid rgba(151, 151, 151, 0.21);padding: 0 2.93vw;width: calc(100% - 2.93vw)" class="centerBox">
            <div style="color: #333333; font-size: 3.47vw;font-weight: bold">订单号: {{item.orderNo}}</div>
            <div style="margin-left: 3.47vw;color: #353535;font-size: 3.2vw;transform: translateY(.3vw)">{{$utils.ymdDate(item.orderTime, '-')}}</div>
            <img src="../../assets/img/order/shzTitle.png" v-if="item.orderStatus === 1" style="width: 13.33vw;position: absolute;right: 5.43vw;top: 2.13vw">
            <img src="../../assets/img/order/yshTitle.png" v-if="item.orderStatus === 2" style="width: 13.33vw;position: absolute;right: 5.43vw;top: 2.13vw">
            <img src="../../assets/img/order/yfkTitle.png" v-if="item.orderStatus === 3" style="width: 13.33vw;position: absolute;right: 5.43vw;top: 2.13vw">
            <img src="../../assets/img/order/yjsTitle.png" v-if="item.orderStatus === 4" style="width: 13.33vw;position: absolute;right: 5.43vw;top: 2.13vw">
          </div>
          <div style="height: calc(25.6vw - 5.07 * 2vw);padding: 5.07vw 2.93vw">
            <div style="justify-content: space-between" class="centerBox">
              <div style="display: flex;align-items: center;width: 67vw;overflow-x: hidden">
                <div  v-for="(children, index) in item.orderItemLists" :key="children.id">
                  <div style="margin-right: 3.73vw" v-if="index < 6">
                    <img :src="children.img" style="width: 10.13vw;height: 10.13vw">
                    <div style="width: 10.13vw;margin-top: 1.33vw;font-size: 2.67vw;color: #535353" class="primaryText">
                      {{children.goodsName}}
                    </div>
                  </div>
                </div>
              </div>
              <div style="font-size: 3.47vw;color: #535353">
                <van-icon v-if="item.orderItemLists > 5" name="ellipsis" style="margin-right: 1.33vw" />
                共{{item.orderItemLists.length}}件
              </div>
            </div>
          </div>
        </div>
        </div>
<!--      <allOrders :type="5"></allOrders>-->
    </van-tab>
    <van-tab name="2">
      <div slot="title" style="position: relative">
        {{'已审核'}}
      </div>
      <div style="overflow-y: auto; background-color: #f6f7f8;height: calc(100vh - 98px)" class="search">
          <van-search
            v-model="form.orderNo"
            show-action
            shape="round"
            ref="searchInput"
            background="white"
            style="position: relative; z-index: 10"
            placeholder="请输入想搜索的订单"
          >
            <div slot="left-icon">
              <img src="../../assets/img/icon/searchGray.png" style="width: 13px;margin-left: 13px;transform: translateY(1px)">
            </div>
            <div style="line-height: 20px;color: #2B2D2F; width: 30px;transform: translateX(5px)" class="centerBox"  slot="action">
              <div style="font-size: 14px;" @click="orderPage">搜索</div>
            </div>
          </van-search>
          <div style="width: 92%;margin: 2.67vw auto;border-radius: 2.67vw; overflow: hidden;background-color: white;position: relative" @click="toDetail(item)" v-for="(item, index) in list" :key="index">
          <div style="position: relative;height: 9.07vw;justify-content: left;border-bottom: .13vw solid rgba(151, 151, 151, 0.21);padding: 0 2.93vw;width: calc(100% - 2.93vw)" class="centerBox">
            <div style="color: #333333; font-size: 3.47vw;font-weight: bold">订单号: {{item.orderNo}}</div>
            <div style="margin-left: 3.47vw;color: #353535;font-size: 3.2vw;transform: translateY(.3vw)">{{$utils.ymdDate(item.orderTime, '-')}}</div>
            <img src="../../assets/img/order/shzTitle.png" v-if="item.orderStatus === 1" style="width: 13.33vw;position: absolute;right: 5.43vw;top: 2.13vw">
            <img src="../../assets/img/order/yshTitle.png" v-if="item.orderStatus === 2" style="width: 13.33vw;position: absolute;right: 5.43vw;top: 2.13vw">
            <img src="../../assets/img/order/yfkTitle.png" v-if="item.orderStatus === 3" style="width: 13.33vw;position: absolute;right: 5.43vw;top: 2.13vw">
            <img src="../../assets/img/order/yjsTitle.png" v-if="item.orderStatus === 4" style="width: 13.33vw;position: absolute;right: 5.43vw;top: 2.13vw">
          </div>
          <div style="height: calc(25.6vw - 5.07 * 2vw);padding: 5.07vw 2.93vw">
            <div style="justify-content: space-between" class="centerBox">
              <div style="display: flex;align-items: center;width: 67vw;overflow-x: hidden">
                <div  v-for="(children, index) in item.orderItemLists" :key="children.id">
                  <div style="margin-right: 3.73vw" v-if="index < 6">
                    <img :src="children.img" style="width: 10.13vw;height: 10.13vw">
                    <div style="width: 10.13vw;margin-top: 1.33vw;font-size: 2.67vw;color: #535353" class="primaryText">
                      {{children.goodsName}}
                    </div>
                  </div>
                </div>
              </div>
              <div style="font-size: 3.47vw;color: #535353">
                <van-icon v-if="item.orderItemLists > 5" name="ellipsis" style="margin-right: 1.33vw" />
                共{{item.orderItemLists.length}}件
              </div>
            </div>
          </div>
        </div>
        </div>
<!--      <allOrders :type="2"></allOrders>-->
    </van-tab>
    <van-tab name="3">
      <div slot="title" style="position: relative">
        {{'已付款'}}
      </div>
      <div style="overflow-y: auto; background-color: #f6f7f8;height: calc(100vh - 98px)" class="search">
          <van-search
            v-model="form.orderNo"
            show-action
            shape="round"
            ref="searchInput"
            background="white"
            style="position: relative; z-index: 10"
            placeholder="请输入想搜索的订单"
          >
            <div slot="left-icon">
              <img src="../../assets/img/icon/searchGray.png" style="width: 13px;margin-left: 13px;transform: translateY(1px)">
            </div>
            <div style="line-height: 20px;color: #2B2D2F; width: 30px;transform: translateX(5px)" class="centerBox"  slot="action">
              <div style="font-size: 14px;" @click="orderPage">搜索</div>
            </div>
          </van-search>
          <div style="width: 92%;margin: 2.67vw auto;border-radius: 2.67vw; overflow: hidden;background-color: white;position: relative" @click="toDetail(item)" v-for="(item, index) in list" :key="index">
          <div style="position: relative;height: 9.07vw;justify-content: left;border-bottom: .13vw solid rgba(151, 151, 151, 0.21);padding: 0 2.93vw;width: calc(100% - 2.93vw)" class="centerBox">
            <div style="color: #333333; font-size: 3.47vw;font-weight: bold">订单号: {{item.orderNo}}</div>
            <div style="margin-left: 3.47vw;color: #353535;font-size: 3.2vw;transform: translateY(.3vw)">{{$utils.ymdDate(item.orderTime, '-')}}</div>
            <img src="../../assets/img/order/shzTitle.png" v-if="item.orderStatus === 1" style="width: 13.33vw;position: absolute;right: 5.43vw;top: 2.13vw">
            <img src="../../assets/img/order/yshTitle.png" v-if="item.orderStatus === 2" style="width: 13.33vw;position: absolute;right: 5.43vw;top: 2.13vw">
            <img src="../../assets/img/order/yfkTitle.png" v-if="item.orderStatus === 3" style="width: 13.33vw;position: absolute;right: 5.43vw;top: 2.13vw">
            <img src="../../assets/img/order/yjsTitle.png" v-if="item.orderStatus === 4" style="width: 13.33vw;position: absolute;right: 5.43vw;top: 2.13vw">
          </div>
          <div style="height: calc(25.6vw - 5.07 * 2vw);padding: 5.07vw 2.93vw">
            <div style="justify-content: space-between" class="centerBox">
              <div style="display: flex;align-items: center;width: 67vw;overflow-x: hidden">
                <div  v-for="(children, index) in item.orderItemLists" :key="children.id">
                  <div style="margin-right: 3.73vw" v-if="index < 6">
                    <img :src="children.img" style="width: 10.13vw;height: 10.13vw">
                    <div style="width: 10.13vw;margin-top: 1.33vw;font-size: 2.67vw;color: #535353" class="primaryText">
                      {{children.goodsName}}
                    </div>
                  </div>
                </div>
              </div>
              <div style="font-size: 3.47vw;color: #535353">
                <van-icon v-if="item.orderItemLists > 5" name="ellipsis" style="margin-right: 1.33vw" />
                共{{item.orderItemLists.length}}件
              </div>
            </div>
          </div>
        </div>
        </div>
<!--      <allOrders :type="3"></allOrders>-->
    </van-tab>
    <van-tab name="8">
      <div slot="title" style="position: relative">
        {{'已结束'}}
      </div>
      <div style="overflow-y: auto; background-color: #f6f7f8;height: calc(100vh - 98px)" class="search">
          <van-search
            v-model="form.orderNo"
            show-action
            shape="round"
            ref="searchInput"
            background="white"
            style="position: relative; z-index: 10"
            placeholder="请输入想搜索的订单"
          >
            <div slot="left-icon">
              <img src="../../assets/img/icon/searchGray.png" style="width: 13px;margin-left: 13px;transform: translateY(1px)">
            </div>
            <div style="line-height: 20px;color: #2B2D2F; width: 30px;transform: translateX(5px)" class="centerBox"  slot="action">
              <div style="font-size: 14px;" @click="orderPage">搜索</div>
            </div>
          </van-search>
          <div style="width: 92%;margin: 2.67vw auto;border-radius: 2.67vw; overflow: hidden;background-color: white;position: relative" @click="toDetail(item)" v-for="(item, index) in list" :key="index">
          <div style="position: relative;height: 9.07vw;justify-content: left;border-bottom: .13vw solid rgba(151, 151, 151, 0.21);padding: 0 2.93vw;width: calc(100% - 2.93vw)" class="centerBox">
            <div style="color: #333333; font-size: 3.47vw;font-weight: bold">订单号: {{item.orderNo}}</div>
            <div style="margin-left: 3.47vw;color: #353535;font-size: 3.2vw;transform: translateY(.3vw)">{{$utils.ymdDate(item.orderTime, '-')}}</div>
            <img src="../../assets/img/order/shzTitle.png" v-if="item.orderStatus === 1" style="width: 13.33vw;position: absolute;right: 5.43vw;top: 2.13vw">
            <img src="../../assets/img/order/yshTitle.png" v-if="item.orderStatus === 2" style="width: 13.33vw;position: absolute;right: 5.43vw;top: 2.13vw">
            <img src="../../assets/img/order/yfkTitle.png" v-if="item.orderStatus === 3" style="width: 13.33vw;position: absolute;right: 5.43vw;top: 2.13vw">
            <img src="../../assets/img/order/yjsTitle.png" v-if="item.orderStatus === 4" style="width: 13.33vw;position: absolute;right: 5.43vw;top: 2.13vw">
          </div>
          <div style="height: calc(25.6vw - 5.07 * 2vw);padding: 5.07vw 2.93vw">
            <div style="justify-content: space-between" class="centerBox">
              <div style="display: flex;align-items: center;width: 67vw;overflow-x: hidden">
                <div  v-for="(children, index) in item.orderItemLists" :key="children.id">
                  <div style="margin-right: 3.73vw" v-if="index < 6">
                    <img :src="children.img" style="width: 10.13vw;height: 10.13vw">
                    <div style="width: 10.13vw;margin-top: 1.33vw;font-size: 2.67vw;color: #535353" class="primaryText">
                      {{children.goodsName}}
                    </div>
                  </div>
                </div>
              </div>
              <div style="font-size: 3.47vw;color: #535353">
                <van-icon v-if="item.orderItemLists > 5" name="ellipsis" style="margin-right: 1.33vw" />
                共{{item.orderItemLists.length}}件
              </div>
            </div>
          </div>
        </div>
        </div>
<!--      <allOrders :type="8"></allOrders>-->
    </van-tab>
  </van-tabs>
</div>
</template>

<script>
// import AllOrders from './allOrders/index'
export default {
  name: 'index',
  // components: { AllOrders },
  data () {
    return {
      telAndName: '',
      active: '',
      pagingData: {
        loading: false,
        finished: false,
        currentPage: 1,
        pageSize: 10
      },
      form: {
        code: '',
        searchCondition: '',
        orderNo: ''
      },
      list: []
    }
  },
  created () {
    this.active = this.$route.query.index || ''
    this.orderPage(this.active)
  },
  methods: {
    onClickLeft () {
      if (this.$route.query.path) {
        this.$router.push({
          path: '/' + this.$route.query.path
        })
      } else {
        this.$router.go(-1)
      }
    },
    onClick (name) {
      this.$router.replace({ path: '/myOrder', query: { index: name } })
      this.orderPage(name)
    },
    orderPage (name) {
      this.$toast.loading({
        duration: 0
      })
      if (name === '0') {
        name = ''
      }
      this.$request.shop.listOrder({
        orderStatus: name,
        orderNo: this.form.orderNo
      })
        .then((response) => {
          this.$toast.clear()
          if (response.code !== '200') {
            this.$toast(response.msg)
            return
          }
          this.list = response.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    toDetail (item) {
      this.$router.push({ name: 'OrderDetail', query: { id: item.id } })
    }
  }
}
</script>

<style scoped>

</style>
